"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calvertTheme = void 0;
var styles_1 = require("@mui/material/styles");
require("@fontsource/open-sans/latin.css");
var typeographyDefaultArgs = {
    fontFamily: 'Open Sans',
    fontSize: '1rem',
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 'normal',
    textTransform: 'none',
    textAlign: 'left',
};
exports.calvertTheme = (0, styles_1.createTheme)({
    // TODO: Fill in Missing color palette options
    //      (see https://app.zeplin.io/project/5e6007d878f87615c9866ce5/screen/5e601d10e15786148260f72a)
    palette: {
        primary: {
            main: '#007abc',
            dark: '#015989',
            light: '#61bbe9',
            contrastText: '#fff',
        },
        secondary: {
            main: '#7686c5', // TODO: Is this the right secondary color?
            contrastText: '#fff',
        },
        error: {
            main: '#d52357',
        },
        warning: {
            main: '#f8b718',
        },
        success: {
            main: '#5ca446',
        },
        action: {
            disabledBackground: '#e0e9ef',
            disabled: '#98adb9',
            hover: '#007389',
        },
        background: {
            paper: '#f3f5f8',
            default: '#fff',
        },
        text: {
            primary: '#4a4a4a',
            secondary: '#363636',
            disabled: '#707070',
        },
    },
    typography: {
        htmlFontSize: 16, // 16px is standard
        fontSize: 14,
        fontFamily: typeographyDefaultArgs.fontFamily,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 700,
        h1: __assign(__assign({}, typeographyDefaultArgs), { fontSize: '2.25rem', fontWeight: 'bold', textTransform: 'capitalize' }),
        h2: __assign(__assign({}, typeographyDefaultArgs), { fontSize: '1.75rem', fontWeight: 'bold', textTransform: 'capitalize', fontFamily: 'Caladea', lineHeight: 1.29 }),
        h3: __assign(__assign({}, typeographyDefaultArgs), { fontSize: '1.375rem', fontWeight: 'bold', textTransform: 'capitalize' }),
        h4: __assign(__assign({}, typeographyDefaultArgs), { fontSize: '1.125rem', fontWeight: 600, textTransform: 'capitalize' }),
        h5: __assign(__assign({}, typeographyDefaultArgs), { fontSize: '1rem', fontWeight: 600, textTransform: 'capitalize' }),
        h6: __assign(__assign({}, typeographyDefaultArgs), { fontSize: '0.875rem', fontWeight: 600, textTransform: 'capitalize' }),
        subtitle1: __assign(__assign({}, typeographyDefaultArgs), { fontSize: '1.125rem', fontWeight: 600 }),
        body1: __assign(__assign({}, typeographyDefaultArgs), { fontSize: '0.9375rem', lineHeight: 1.62 }),
        body2: __assign(__assign({}, typeographyDefaultArgs), { fontSize: '0.875rem', lineHeight: 1.62 }),
        caption: __assign(__assign({}, typeographyDefaultArgs), { fontSize: '0.75rem', lineHeight: '0.75rem' }),
        button: __assign(__assign({}, typeographyDefaultArgs), { fontSize: '0.8125rem', fontWeight: 'bold', textTransform: 'capitalize' }),
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 480,
            md: 600,
            lg: 960,
            xl: 1280,
        },
    },
});
